import { CellContext } from "@tanstack/react-table";
import { VariantWithProductData } from "../types";
import { setBagSizeCellTestId } from "../products-table.utils";

export const BagSizeCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const data = props.row.original;

  return (
    <div className="flex flex-col" data-testid={setBagSizeCellTestId(props.row.index)}>
      <span className="font-medium text-sm whitespace-nowrap">{data.bagSize}</span>
      <span className="text-xs text-muted-foreground">{data.title}</span>
    </div>
  );
};
